module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table",
    class: _vm.tableClass
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(c) {
    return _c('th', {
      key: c
    }, [_vm._v(_vm._s(c))])
  }))]), _c('tbody', _vm._l((_vm.data), function(item) {
    return _c('tr', {
      key: item
    }, _vm._l((_vm.columns), function(c) {
      return (_vm.hasValue(item, c)) ? _c('td', {
        key: c
      }, [_vm._v(_vm._s(_vm.itemValue(item, c)))]) : _vm._e()
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e756db52","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/mdTable/index.vue
// module id = KlBX
// module chunks = 13 14